import React from 'react';
import styled from 'styled-components';
import {Modal, Button, Input, Form} from 'antd';
import {useOutlet} from 'reconnect.js';
import * as User from 'rev.sdk.js/Actions/User';
import * as AppActions from '../../AppActions';

const L = AppActions.L;

// @sdk-next
function ResetPasswordModal(props) {
  const [info, setVisible] = useOutlet('reset-password-modal');
  const visible = !!info;
  let admin = info && info.admin;

  const onFinish = async (values) => {
    const {org_password, new_password, new_password1} = values;

    if (!org_password) {
      alert('不可為空');
      return;
    }

    if (new_password !== new_password1) {
      alert('兩次新密碼輸入不相符');
      return;
    }

    await AppActions.setLoading(true);
    try {
      await User.resetPassword({org_password, new_password}, admin);
    } catch (ex) {
      console.warn('EX', ex);
      alert('API failed');
    } finally {
      setVisible(false);
    }
    await AppActions.setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Modal
      destroyOnClose={true}
      title={null}
      footer={null}
      bodyStyle={{padding: 0}}
      width={500}
      visible={visible}
      onOk={() => {
        setVisible(false);
      }}
      onCancel={() => {
        setVisible(false);
      }}>
      <Wrapper>
        <Center>
          <h2>
            {admin ? 'ADMIN' : ''}
            {L('reset_password')}
          </h2>
          <Form
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            colon={false}>
            <Form.Item
              label={L('original_pwd')}
              name="org_password"
              rules={[
                {
                  required: true,
                  message: '舊密碼不可為空',
                },
              ]}>
              <Input.Password />
            </Form.Item>

            <Form.Item
              label={L('new_pwd')}
              name="new_password"
              rules={[
                {
                  required: true,
                  message: '新密碼不可為空',
                },
              ]}>
              <Input.Password />
            </Form.Item>

            <Form.Item
              label={L('new_pwd_again')}
              name="new_password1"
              rules={[
                {
                  required: true,
                  message: '新密碼不可為空',
                },
              ]}>
              <Input.Password />
            </Form.Item>

            <Form.Item style={{textAlign: 'right'}}>
              <Button type="primary" htmlType="submit">
                {L('submit')}
              </Button>
            </Form.Item>
          </Form>
        </Center>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  padding: 20px;

  & h2 {
    font-weight: 300;
    margin-bottom: 30px;
  }

  & .ant-form-item-label {
    width: 170px;
    text-align: left;
    & > label {
      color: var(--text-4-color);
      font-weight: 300;
    }
  }
`;

const Center = styled.div`
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
`;

export default ResetPasswordModal;
